<template>
  <IconWrapper :dense="dense">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.625 10.5H11.0325L10.8225 10.2975C11.7225 9.24748 12.1875 7.81498 11.9325 6.29248C11.58 4.20748 9.83998 2.54248 7.73998 2.28748C4.56748 1.89748 1.89748 4.56748 2.28748 7.73998C2.54248 9.83998 4.20748 11.58 6.29248 11.9325C7.81498 12.1875 9.24748 11.7225 10.2975 10.8225L10.5 11.0325V11.625L13.6875 14.8125C13.995 15.12 14.4975 15.12 14.805 14.8125C15.1125 14.505 15.1125 14.0025 14.805 13.695L11.625 10.5ZM7.12498 10.5C5.25748 10.5 3.74998 8.99248 3.74998 7.12498C3.74998 5.25748 5.25748 3.74998 7.12498 3.74998C8.99248 3.74998 10.5 5.25748 10.5 7.12498C10.5 8.99248 8.99248 10.5 7.12498 10.5Z"
      />
    </svg>
  </IconWrapper>
</template>

<script>
import IconWrapper from './IconWrapper'

export default {
  components: {
    IconWrapper
  },

  props: {
    dense: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg path {
  fill: var(--r-white-5);
}
</style>
